import strings from 'common/Translation/Translate';
import PrimaryButton from 'components/Button/PrimaryButton';

type AirpayFormProps = {
  responseValue: any,
  isChecked: any,
};
const AirPayForm = ({ responseValue, isChecked }: AirpayFormProps) => {
  return (
    <div>
      {responseValue.paymentGatewayInfo && (
        <form method="POST" action={responseValue.paymentGatewayInfo.url}>
          <input type="hidden" name="merchant_id" value={`${responseValue.paymentGatewayInfo.merchantId}`} />
          <input type="hidden" name="privatekey" value={`${responseValue.paymentGatewayInfo.privateKey}`} />
          <input type="hidden" name="encdata" value={`${responseValue.paymentGatewayInfo.encData}`} />
          <input type="hidden" name="checksum" value={`${responseValue.paymentGatewayInfo.checksum}`} />

          <PrimaryButton disabled={!isChecked} type="submit">
            {strings.makePayment}
          </PrimaryButton>
        </form>
      )}
    </div>
  );
};
export default AirPayForm;
